function MB_sleep(t = 1000) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, t);
  });
}
async function MB_jsDeferHandle(method, waitObj = []) {
  for (let i = 0; i < 1000; i++) {
    let status = true;
    for (const item of waitObj) {
      if (!window[item]) {
        status = false;
        break;
      }
    }
    if (status) break;
    await MB_sleep(50);
  }
  method();
}
async function MB_waitElementReady(
  element,
  isExist = true,
  preTime = 10,
  total = 999
) {
  for (let i = 0; i < total; i++) {
    // console.log(document.querySelectorAll(element).length,element,'mibao')
    if (
      (document.querySelectorAll(element).length > 0 && isExist) ||
      (document.querySelectorAll(element).length == 0 && !isExist)
    ) {
      break;
    }
    await MB_sleep(preTime);
  }
}
async function MB_apiFetch(url, type = "GET", data = null) {
  const params = {
    method: type,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  };
  data && (params["body"] = JSON.stringify(data));
  const response = await fetch(url, params);
  return response.json();
}
function MB_setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function MB_getCookie(cname) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const reg = new RegExp(`${cname}=(.*?);`);
  const res = reg.exec(decodedCookie);
  return res ? res[1] : null;
}
function MB_getUrlParam(paramName) {
  // const regex = new RegExp(`[?&]${paramName}=([^&]*)`, 'g');
  // var match = window.location.search.match(
  // 	'[?&]' + paramName + '(?:&|$|=([^&]*))'
  // );
  // return match ? (match[1] ? match[1] : '') : null;

  const regex = new RegExp(`${paramName}=(.*?)(&|$)`, "g");
  const matches = location.search.match(regex);
  if (matches) {
    const values = matches.map((match) => match.split("=")[1].replace(/&/, ""));
    if (values.length > 1) {
      return values;
    } else {
      return values[0].replace(/&/, "");
    }
  } else {
    return null;
  }
}
// async function onColorSwatchChange() {
//   const el = ".t4s-swatch__item.mibao_many_line_color";
//   await MB_waitElementReady(el);
//   $(el).click(function () {
//     const color = $(this).text();
//     const title = $(this).prevAll("h4").first();
//     $(".mibao-swatch__current").text("");
//     title.find(".mibao-swatch__current").text(color);
//     // console.log(this, $(this).prevAll('h4'), title)
//   });
// }

(function () {
  let price_tips = []
  let count_tips = []
  // 德文
  if (window.Shopify.routes.root == '/') {
    price_tips = [
      `Es fehlen Ihnen nur noch €{{rest}} zu €{{discount}} RABATT.`,
      `€{{amount}} sparen mit "{{code}}". Noch €{{rest}} für €{{discount}} Rabatt`,
      `Gutscheincode "<b id="coupon-code">{{code}}</b>" für €{{discount}} Rabatt.`,
    ]
    count_tips = [
      `{{rest}} Artikel mehr hinzufügen, <b>{{discount}} gratis bekommen</b>.`,
      `Mit Code <b>{{code}}</b>: {{rest}} Artikel kaufen, <b>{{discount}} gratis</b> dazu erhalten!`,
      `Nutzen Sie code <b id="coupon-code">{{code}}</b> für <b>{{discount}} Kostenlose</b>.`
    ]
  } else {
    price_tips = [
      `You are only €{{rest}} away from €{{discount}} OFF.`,
      `Save €{{amount}} Code:<b>{{code}}</b>, or add €<b>€{{rest}}</b> for €{{discount}} OFF.`,
      `Use <b id="coupon-code">{{code}}</b> for €{{discount}} OFF.`,
    ]
    count_tips = [
      `Add <b>{{rest}}</b> more items to get <b>{{discount}} Free</b>.`,
      `Use code <b>{{code}}</b>. Add <b>{{rest}}</b> more items to get <b>{{discount}} Free</b>.`,
      `Use code <b id="coupon-code">{{code}}</b> for <b>{{discount}} Free</b>.`
    ]
  }
  // 监听mini cart元素变化
  async function watchMiniCartAndShowDiscountInfo() {
    // let is_code_apply = false;
    $(window).on("cart:inited", cartHandle);
    $(window).on("cart:updated", cartHandle);
    async function cartHandle(e) {
      // 初始化add按钮
      window.addEventAddMore && window.addEventAddMore()
      // CopyShipTextToAddMore()
      // onColorSwatchChange()
      console.log('cartHandle------', e)
      // 先隐藏折扣信息
      $("#t4s-mini_cart .mibao_coupon_input #tips").hide(100);
      // 清除折扣码
      $("#t4s-mini_cart .mibao_coupon_input input").val("");

      let info;
      let is_show_info = false;
      let show_copy = false
      // 购物车件数
      const item_count = window.mibaoCartData.items.reduce((acc, item) => window.mibao_cart_discount_info_rules.vaild_products.includes(item.product_id.toString()) ? acc + item.quantity : acc, 0)
      console.log('item_count', item_count)
      // 购物车原价总数
      const original_total_price =
        Number(
          $(".t4s-cart__totalPrice #mibao_cart_original_total_price").val()
        )
      if (
        window.mibao_cart_discount_info_rules &&
        window.mibao_cart_discount_info_rules.show == 1
      ) {
        const coupon_rule = {
          type: window.mibao_cart_discount_info_rules.type,
          rules:
            window.mibao_cart_discount_info_rules.type == "price"
              ? window.mibao_cart_discount_info_rules.price_rules
              : window.mibao_cart_discount_info_rules.count_rules,
        };
        // 匹配规则
        const currency_rate = Number(Number(Shopify?.currency?.rate || 1)) * 10000000
        let index = 1
        function calc_price(rule) {
          function getCurrencyPrice(price) {
            let res = T4Sconfigs.moneyFormat.replace(/\{\{(amount_with_comma_separator|amount)\}\}/g, price)
            return res
          }
          console.log('rule.min * currency_rate', rule.min * currency_rate)
          const min_price = rule.min * currency_rate
          const max_price = rule.max * currency_rate
          const discount_price = rule.discount * currency_rate
          const original_total_price_100000 = original_total_price * 100000
          const rest_price = max_price - original_total_price_100000;
          const discount_price_currency = getCurrencyPrice((discount_price / 10000000).toFixed(2))
          const rest_price_currency = getCurrencyPrice((rest_price / 10000000).toFixed(2))
          if (
            min_price &&
            max_price &&
            !rule.code &&
            original_total_price_100000 > min_price &&
            original_total_price_100000 <= max_price
          ) {
            let tips_info = price_tips[0].replace('{{rest}}', rest_price_currency)
            tips_info = tips_info.replace('{{discount}}', discount_price_currency)
            info = tips_info
            is_show_info = true;
            return true
          } else if (
            min_price &&
            max_price &&
            original_total_price_100000 > min_price &&
            original_total_price_100000 <= max_price
          ) {
            const toFixed_2 = (coupon_rule.rules[index - 1].discount * currency_rate / 10000000).toFixed(2)
            const last_rule_discount_price_currency = getCurrencyPrice(toFixed_2)
            let tips_info = price_tips[1].replace('{{amount}}', last_rule_discount_price_currency)
            tips_info = tips_info.replace('{{code}}', rule.code)
            tips_info = tips_info.replace('{{rest}}', rest_price_currency)
            tips_info = tips_info.replace('{{discount}}', discount_price_currency)
            info = tips_info
            is_show_info = true;
            index++
            return true
          } else if (min_price && !max_price && original_total_price_100000 > min_price) {
            let tips_info = price_tips[2].replace('{{code}}', rule.code)
            tips_info = tips_info.replace('{{discount}}', discount_price_currency)
            info = tips_info
            is_show_info = true;
            show_copy = true;
            return true
          }
        }

        function calc_count(rule) {
          if (
            rule.min &&
            rule.max &&
            !rule.code &&
            item_count > rule.min &&
            item_count <= rule.max
          ) {
            const rest_count = rule.max - item_count;
            let tips_info = count_tips[0].replace('{{rest}}', rest_count + 1)
            tips_info = tips_info.replace("{{discount}}", rule.discount)
            info = tips_info;
            is_show_info = true;
            return true
          } else if (
            rule.min &&
            rule.max &&
            item_count > rule.min &&
            item_count <= rule.max
          ) {
            const rest_count = rule.max - item_count;
            let tips_info = count_tips[1].replace('{{rest}}', rest_count + 1)
            tips_info = tips_info.replace("{{discount}}", rule.discount)
            tips_info = tips_info.replace("{{code}}", rule.code)
            info = tips_info
            is_show_info = true;
            index++
            return true
          } else if (rule.min && !rule.max && item_count > rule.min) {
            let tips_info = count_tips[2].replace("{{discount}}", rule.discount)
            tips_info = tips_info.replace("{{code}}", rule.code)
            info = tips_info
            is_show_info = true;
            show_copy = true;
            return true
          }
        }

        const calc_method = coupon_rule.type == "price" ? calc_price : calc_count

        for (rule of coupon_rule.rules) {
          if (calc_method(rule)) {
            break
          }
        }
      }
      if (is_show_info) {
        $("#t4s-mini_cart .mibao_coupon_info").show(300);
        $("#t4s-mini_cart .mibao_coupon_info #tips").html(info);
      } else {
        $("#t4s-mini_cart .mibao_coupon_info").hide(300);
      }

      if (show_copy) {
        $("#t4s-mini_cart .mibao_coupon_info #copy").show()
        $("#t4s-mini_cart .mibao_coupon_info #add_more_btn").hide()
      } else {
        $("#t4s-mini_cart .mibao_coupon_info #copy").hide()
        $("#t4s-mini_cart .mibao_coupon_info #add_more_btn").show()
      }
    }

    await MB_waitElementReady(
      "#t4s-mini_cart .mibao_coupon_input .t4s-field button",
      (preTime = 500),
      (total = 100)
    );

    $("#t4s-mini_cart .mibao_coupon_input .t4s-field input").on(
      "keydown",
      function () {
        $("#t4s-mini_cart .mibao_coupon_input .tips").hide(300);
      }
    );
    $("#t4s-mini_cart .mibao_coupon_input .t4s-field button").click(
      async function () {
        $("#t4s-mini_cart .mibao_coupon_input .t4s-field button").attr(
          "disabled",
          true
        );
        const code = $("#t4s-mini_cart .mibao_coupon_input input").val();
        if (code) {
          $(
            "#t4s-mini_cart [data-cart-discounts] .t4s-cart_discounts"
          ).remove();
          $("#t4s-mini_cart[data-cart-wrapper]").addClass("is--contentUpdate");
          $("#t4s-mini_cart [data-cart-item]").addClass("is--update");
          $("#t4s-mini_cart [data-cart-item]")
            .find(".t4s-cart-ld__bar")
            .removeAttr("hidden");
          $("#t4s-mini_cart [data-cart-item]")
            .find(".t4s-cart-spinner")
            .removeAttr("hidden");

          await $.get(`/discount/${code}`);
          await MB_sleep(100);
          await T4SThemeSP.Cart.getToFetch();
          is_code_apply = true;

          $("#t4s-mini_cart[data-cart-wrapper]").removeClass(
            "is--contentUpdate"
          );
          $("#t4s-mini_cart [data-cart-item]").removeClass("is--update");
          $("#t4s-mini_cart [data-cart-item]")
            .find(".t4s-cart-ld__bar")
            .attr("hidden", "");
          $("#t4s-mini_cart [data-cart-item]")
            .find(".t4s-cart-spinner")
            .attr("hidden", "");
        }
        $(this).removeAttr("disabled");
        // await MB_waitElementReady('#t4s-mini_cart [data-cart-discounts] .t4s-cart_discounts', preTime=50, total=30)
        // await MB_sleep(1500)
      }
    );
    // function show_tips() {
    //   if (
    //     $("#t4s-mini_cart [data-cart-discounts] .t4s-cart_discounts").length
    //   ) {
    //     $("#t4s-mini_cart .mibao_coupon_input .tips").hide(300);
    //   } else {
    //     let tips = "";
    //     if (
    //       $("#t4s-mini_cart .t4s-mini_cart__item .t4s-cart_discount_price")
    //         .length
    //     ) {
    //       tips = "Saved code. Click to checkout.";
    //     } else {
    //       tips = "Invalid code. Redeem Gift Card at checkout.";
    //     }
    //     $("#t4s-mini_cart .mibao_coupon_input .tips").text(tips);
    //     $("#t4s-mini_cart .mibao_coupon_input .tips").hide().show(300);
    //   }
    // }
  }
  // 包装袋添加
  async function cartGiftWrapHandle() {
    await MB_waitElementReady("[data-mibao-cart-gift-wrap-submit]");
    $("[data-mibao-cart-gift-wrap-submit]").click(async function (e) {
      e.preventDefault();
      $(this).next(".mibao-tips").hide();
      $(this).addClass("is--loading").attr("aria-disabled", true);
      const items = [];
      $(".mibao_cart_gift_wrap")
        .find("[data-cart-item]")
        .each(function () {
          const id = $(this).attr("data-variant-id");
          const quantity = parseInt(
            $(this)
              .find("[data-quantity-wrapper]")
              .find("[data-quantity-value]")
              .val()
          );
          if (quantity > 0) {
            items.push({
              id,
              quantity,
            });
          }
        });
      if (!items.length) {
        $(this).next(".mibao-tips").text("You must add A Box!!");
        $(this).next(".mibao-tips").show();
      } else {
        const data = {
          sections:
            location.pathname == "/cart"
              ? "cart_data,main-cart"
              : "cart_data,mini_cart",
          sections_url: location.pathname,
          items,
        };
        const response = await MB_apiFetch(
          `${T4Sroutes.cart_add_url}.js`,
          "POST",
          data
        );
        window.mibaoCartData = response;
        await MB_sleep(500);
        const o = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/javascript`,
            "X-Requested-With": "XMLHttpRequest",
          },
        };
        o.body = JSON.stringify(data);
        $(document).trigger("add:cart:success", [o]).trigger("add:cart:upsell");

        window.mibaoCartData = response;
        await MB_sleep(500);
        T4SThemeSP.Cart.renderContents(response.sections);
      }
      $(this).removeClass("is--loading").removeAttr("aria-disabled");
    });
  }

  // 修改产品右上角标的显示条件
  async function setProductBadges() {
    await MB_waitElementReady(
      ".bg_color_ntloading",
      (isExist = false),
      (preTime = 50)
    );
    $("[data-product-single-badge]").each(function () {
      const data = $(this)
        .parents("[data-product-featured]")
        .data("product-featured");
      if (!data.available) {
        $("[data-main-media] .flickityt4s-viewport").css(
          "--showProductSoldOutBadge",
          "flex"
        );
      }
    });
    $("[data-product-badge]").each(function () {
      if (!$(this).hasClass("isCheck")) {
        const data = $(this).parents(".t4s-product").data("product-options");
        const parent = $(this).parents(".t4s-product-wrapper");
        parent
          .find(".t4s-product-inner .t4s-product-img")
          .after("<div class='mibao_badge_left_top'></div>");
        parent
          .find(".t4s-product-inner .t4s-product-img")
          .after("<div class='mibao_badge_left_bottom'></div>");
        if (data.sizingType_size > 0 && $(this).find(".t4s-badge-sizing_type").length == 0) {
          const html = `<span class="t4s-badge-item t4s-badge-sizing_type mibao">${data.sizingType_size} lengths</span>`;
          parent.find(".mibao_badge_left_top").append(html);
        } else if (data.isNew && $(this).find(".t4s-badge-new").length == 0) {
          const html = `<span class="t4s-badge-item t4s-badge-new mibao">NEW</span>`;
          // $(this).append(html)
          parent.find(".mibao_badge_left_top").append(html);
          // parent.find('.t4s-product-info__inner').prepend(html)
        }
        if (
          data.isSellingFast &&
          $(this).find(".t4s-badge-selling_fast").length == 0
        ) {
          const html = `<span class="t4s-badge-item t4s-badge-selling_fast mibao">BEST SELLER</span>`;
          // $(this).append(html
          parent.find(".mibao_badge_left_bottom").append(html);
          // parent.find('.t4s-product-info__inner').prepend(html)
        }
        if (data.isBackIn && $(this).find(".t4s-badge-back_in").length == 0) {
          const html = `<span class="t4s-badge-item t4s-badge-back_in mibao">BACK IN</span>`;
          // $(this).append(html)
          parent.find(".mibao_badge_left_top").append(html);
          // parent.find('.mibao_badge_left_bottom').append(html)
          // parent.find('.t4s-product-info__inner').prepend(html)
        }
        // if (!data.available) {
        //   $(this)
        //     .parents(".t4s-product")
        //     .find(".t4s-product-wrapper")
        //     .css("--showProductSoldOutBadge", "flex");
        //   // console.log('sold out')
        // }
        $(this).addClass("isCheck");
      }
    });
  }
  // 设置菜单栏
  async function initHeaderMenu() {
    // 阻止头部菜单有二级了菜单的栏目点击动作
    $("header .t4s-navigation a[href='/']").on("click", function (e) {
      console.log(e);
      e.preventDefault();
    });

    // 展开移动端的菜单栏
    await MB_waitElementReady("ul.t4s-mb__menu li:nth-child(4)");
    await MB_sleep(200);
    // $("ul.t4s-mb__menu>li:nth-child(4)>a").click()

    // 展开底部菜单
    await MB_waitElementReady(
      "#shopify-section-footer .t4s-footer-wrap .t4s-custom-col:nth-child(5) .t4s-footer-heading"
    );
  }
  function onScroll() {
    if (document.querySelector(".bg_color_ntloading") == null) {

      MB_jsDeferHandle(setProductBadges, ["jQuery"]);
    }
  }
  // 倒计时去除0天的显示
  // async function countdownDaysLess1_2() {
  //   await MB_waitElementReady(
  //     ".mibao-countdown .t4s-countdown-enabled .day",
  //     (preTime = 50),
  //     (total = 100)
  //   );
  //   $(".mibao-countdown").each(async function () {
  //     for (let i = 0; i < 100; i++) {
  //       const days = $(this).find(".t4s-countdown-enabled b.day").text();
  //       if (days != "%d") {
  //         if (days == "00" || days == "0") {
  //           $(this).addClass("days_less1");
  //         }
  //         break;
  //       }
  //       await MB_sleep(100);
  //     }
  //   });
  // }

  function addWishListBtnEvent() {
    document.body.addEventListener('click', function (event) {
      const wishListBtn = event.target.closest('.t4s-pr-wishlist');
      if (!wishListBtn) {
        return
      }
      const productId = wishListBtn.dataset.id;
      if (wishListBtn.classList.contains("is--added") || wishListBtn.dataset.hasOwnProperty("removeWishlist")) {
        Shopify.analytics.publish("wishlist", {
          event_type: 'remove_wishlist',
          productId: productId
        });
        return
      }
      Shopify.analytics.publish("wishlist", {
        event_type: 'add_wishlist',
        productId: productId
      });
    })
  }

  function init() {
    MB_jsDeferHandle(initHeaderMenu, ["jQuery"]);
    MB_jsDeferHandle(setProductBadges, ["jQuery"]);
    MB_jsDeferHandle(watchMiniCartAndShowDiscountInfo, ["jQuery"]);
    MB_jsDeferHandle(addWishListBtnEvent, ["jQuery"]);
    MB_jsDeferHandle(cartGiftWrapHandle, ["jQuery"]);
    // MB_jsDeferHandle(countdownDaysLess1_2, ["jQuery"]);
    window.addEventListener(
      "scroll",
      () => {
        onScroll();
      },
      false
    );
  }
  MB_jsDeferHandle(init, ["jQuery"]);

  // 从url参数中提取数据，记录到cookies
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  MB_setCookie("click_id", urlParams.get("click_id"), 7);
  MB_setCookie("offer_id", urlParams.get("offer_id"), 7);
  // frequently-bought-together 加购后处理
  document.addEventListener(
    "codeblackbelt:frequently-bought-together:added",
    async function (event) {
      await T4SThemeSP.Cart.getToFetch();
      T4SThemeSP.Drawer.opend($("#t4s-mini_cart"));
    }
  );
})();
